import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SearchResultsPane from 'components/search/SearchResultsPane.vue';
import SearchResultDetailsPane from 'components/search/SearchResultDetailsPane.vue';
import {useSearchStore} from 'stores/search-store';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchPane',
  setup(__props) {

const searchStore = useSearchStore();


return (_ctx: any,_cache: any) => {
  const _component_q_splitter = _resolveComponent("q-splitter")!

  return (_openBlock(), _createBlock(_component_q_splitter, {
    class: "search-panel-area",
    "model-value": _unref(searchStore).isTableModeSelected ? 100 : 40,
    limits: _unref(searchStore).isTableModeSelected ? [0, 100] : [40, 70],
    disable: _unref(searchStore).isTableModeSelected,
    "before-class": {'search-panel': true, 'search-panel__left': !_unref(searchStore).isTableModeSelected, 'search-panel__single': _unref(searchStore).isTableModeSelected},
    "after-class": "search-panel search-panel__right",
    "separator-class": { 'search-separator': true, 'search-separator__hidden': _unref(searchStore).isTableModeSelected }
  }, _createSlots({
    before: _withCtx(() => [
      _createVNode(SearchResultsPane)
    ]),
    separator: _withCtx(() => []),
    _: 2
  }, [
    (!_unref(searchStore).isTableModeSelected)
      ? {
          name: "after",
          fn: _withCtx(() => [
            _createVNode(SearchResultDetailsPane)
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["model-value", "limits", "disable", "before-class", "separator-class"]))
}
}

})